(function () {
  document.addEventListener('theme:variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    const product = event.target.closest('product-component');
    const offer = product && product.querySelector('[data-mix-match-price]');
    if (!offer || !variant) return;

    offer.hidden = !variant.available || variant.price <= 0 ||
      (variant.compare_at_price > variant.price);
    if (offer.hidden) return;

    const percent = Number(offer.dataset.discountPercent);
    const price = Math.round(variant.price * (100 - percent) / 100);
    offer.querySelector('[data-mix-match-amount]').innerHTML =
      window.theme.formatMoney(price, window.theme.moneyFormat);
  });
})();
